import { emissionActions } from './actions';
import { useGetItems } from '../hooks';
import { EmissionItem } from '../../api';


const emissionsPath = 'emission';

export const useEmissions = () => useGetItems<EmissionItem[]>({
    path: emissionsPath,
    loadAction: emissionActions.getEmissions,
});
